<template>
<div class="chapter">
<div class="inner_page">
<p class="p9"><span class="t7">Life is neither good or evil, but only a place for good and evil.</span></p>
<p class="p10"><span class="t7">—Marcus Aurelius.</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 006.vue?4d79a141